import type { PuAiSummary, PuPatient, PuPractice, PuUnscheduledTreatment } from './types';

export const PU_PATIENT: PuPatient = {
  preferredName: '',
  fullName: '',
  surname: '',
  initials: '',
  dobMatch: '',
  unscheduledValue: 0,
  insurance: {
    carrier: '',
    annualMax: 0,
    used: 0,
    remaining: 0,
    resetDate: '',
    resetsInDays: 0,
    familyPool: false,
  },
};

export const PU_PRACTICE: PuPractice = {
  name: '',
  logoMark: '',
  tagline: '',
  address: '',
  phone: '',
  bookingUrl: '',
  language: { current: 'en', available: ['en'] },
};

export const PU_AI_SUMMARY: PuAiSummary = { generatedAt: '', body: '' };
export const PU_UNSCHEDULED_TREATMENTS: PuUnscheduledTreatment[] = [];
